/**
 * Normalize domain
 *
 * @param domain Domain to normalize
 * @returns Normalized domain
 */
export function normalizeDomain(domain) {
    return domain.replace('-', '_');
}
//# sourceMappingURL=utils.js.map